import axios from "axios";

interface getInfoSignatoryProps {
  user: {
    id: number;
    created_at: string;
    updated_at: string;
    uuid: string;
    name: string;
    email: string;
    document: string;
    phone: string;
    date_birth: string;
    active: number;
    status: number;
  };
  signature_request: string;
}
export const getSessionStorageValue = (name: string) => {
  const value = sessionStorage.getItem(name);
  return value ? value : "";
};
export const getInfoSignatory = async (): Promise<
  getInfoSignatoryProps | undefined
> => {
  const url = process.env.REACT_APP_API_BASEURL;
  const urlID = window.location.search;
  const urlParams = new URLSearchParams(urlID);
  const id = urlParams.get("id");
  const token = getSessionStorageValue("token_user");

  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${url}/signatories/profile/${id}`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
